import axios from 'axios'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import store from '@/store'
import router from '@/router'

NProgress.configure({ showSpinner: false, trickleSpeed: 200 })

const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || '/api',
  timeout: 60000
})

// 请求拦截：自动附加 JWT Token + 进度条
request.interceptors.request.use(
  config => {
    NProgress.start()
    const token = store.getters['auth/token']
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    NProgress.done()
    return Promise.reject(error)
  }
)

// 响应拦截：统一处理错误
request.interceptors.response.use(
  response => {
    NProgress.done()
    // Blob / ArrayBuffer 等非 JSON 响应直接返回
    if (response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer') {
      return response.data
    }
    const res = response.data
    // 后端业务逻辑错误（success=false）
    if (res && res.success === false) {
      // 401 = 未登录，跳转到登录页（已在登录/注册页则不跳，让错误信息正常显示）
      if (res.code === 401) {
        const cur = router.currentRoute.name
        if (cur !== 'Login' && cur !== 'Register') {
          store.dispatch('auth/logout')
          router.push({ name: 'Login', query: { redirect: router.currentRoute.fullPath } })
        }
      }
      // 403 = 无订阅权限，跳转到定价页
      if (res.code === 403) {
        router.push({ name: 'Pricing' })
      }
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  error => {
    NProgress.done()
    if (error.response) {
      const { status, data } = error.response
      // 优先使用后端响应体中的 message 字段
      const backendMsg = data && data.message
      if (status === 401) {
        store.dispatch('auth/logout')
        router.push({ name: 'Login' })
      }
      return Promise.reject(new Error(backendMsg || error.message || '请求失败'))
    }
    return Promise.reject(error)
  }
)

export default request
